/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useEffect } from 'react';
import Layout from 'antd/lib/layout/layout';
import { Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import PageTitle from '../../lib/page-title';
import addBtn from '../../../assets/icons/plusBtn.svg';
import getManageGroupTypes from './use-getManageGroupTypesData';
import './manage-group-types.less';
import ManageGroupTypeCard from './manage-group-type-card';
import { CREATE_GROUP_TYPE_PATH, EDIT_GROUP_TYPE_PATH } from '../../routing/paths.constants';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';
import { USER_ID } from '../../../store/modules/user/user.constants';
import { useActions } from '../../providers/actions-provider/actions.context';
import PermissionProvider from '../../providers/permissionProvider';
import checkPermission from '../../../utils/permissions/permissions';

const ManageGroupTypes = () : JSX.Element => {
  const { loading, data } = getManageGroupTypes();
  const { userActions } = useActions();
  const { push } = useHistory();
  const hasNotWritePermission = !checkPermission('organization', 'write');

  const localStorageService = useLocalStorage();
  const userID: number | null = localStorageService.get(USER_ID);
  useEffect(() => {
    if (userID) {
      userActions.getCurrentUser(+userID);
    }
  }, []);

  const redirectToGroupTypeCreation = useCallback(() => {
    push(CREATE_GROUP_TYPE_PATH);
  }, []);

  const redirectToGroupTypeEdit = useCallback((id:number) => {
    push(`${EDIT_GROUP_TYPE_PATH}/${id}`);
  }, []);

  return (
    <Layout className="main-container">
      <PermissionProvider pageId="organization">
        <PageTitle title="Organizational Structure" />
        <div className="groupType__container">

          {
            loading
              ? <Spin style={{ margin: 'auto' }} size="large" />
              : (
                <>
                  {
                    data.map((item) => (
                      <ManageGroupTypeCard
                        key={item.id}
                        icon={item.icon}
                        title={item.name}
                        id={item.id}
                        onPress={redirectToGroupTypeEdit}
                      />
                    ))
                  }
                  {hasNotWritePermission ? '' : (
                    <button onClick={redirectToGroupTypeCreation} type="button" className="groupType-card groupType-card--add">
                      <div className="groupType-card__add-btn">
                        <img src={addBtn} alt="Add group-type" />
                      </div>
                    </button>
                  )}
                </>
              )
          }
        </div>
      </PermissionProvider>
    </Layout>
  );
};

ManageGroupTypes.displayName = 'ManageGroupTypes';

export default ManageGroupTypes;
